import { Injectable } from '@angular/core';
import { PendoTrackEvent } from './pendo-track-event';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const pendo: any;

@Injectable({
    providedIn: 'root'
})
export class PendoService {
    public trackEvent(event: PendoTrackEvent): void {
        try {
            pendo.track(event.Type, event.Body);
        } catch (error) {
            console.error(error);
        }
    }
}
